
import moment from 'moment'
import currencyFormat from '~/ZenOne-StoryBook/mixins/currencyFormat'
import { CLIENT_PRICE_VALUE } from '~/ZenOne-StoryBook/components/Distributor/DialogPriceBulkUpload/helper'

export default {
  name: 'ProductPriceValue',
  mixins: [currencyFormat],
  props: {
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    isPriceAvailable: {
      type: Boolean,
      default: false,
    },
    priceValue: {
      type: String,
      default: '',
    },
    productDetailLinkData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    noPriceTooltipText() {
      return 'Click on the product to see your client price in real time'
    },
    showTextPrice() {
      const { priceValue } = this
      if (
        (typeof priceValue === 'string' && priceValue.length > 5) ||
        priceValue !== 'N/A'
      )
        return true
      if (typeof priceValue === 'number') return priceValue < 10000
      return false
    },
    actualPrice() {
      return this?.item?.price?.actualPrice ?? {}
    },
    clientPriceLastCheckAt() {
      if (this.actualPrice?.type !== CLIENT_PRICE_VALUE) return ''
      return this.actualPrice?.lastCheckedAt
        ? `Last time price was updated on ${moment(
            this.actualPrice.lastCheckedAt
          ).format('MM/DD/YY')}`
        : null
    },
    showLastCheckedAt() {
      return !!this.clientPriceLastCheckAt
    },
  },
}
